import DatabaseModel from './DatabaseModel.js';

// Adapter para la generación masiva de items enriquecidos desde expedientes.
// Endpoints bajo /itemsenriquecidos/generacion/*.
var GeneracionItems = Object.create(DatabaseModel);

GeneracionItems.model = 'itemsenriquecidos';
GeneracionItems.modelFront = 'itemsenriquecidos';

/** Cabecera Authorization desde la sesión de localStorage. */
GeneracionItems._authHeaders = function() {
    try {
        var session = JSON.parse(localStorage.getItem('session') || 'null');
        var token = session && (session.token || session.access_token);
        if (token) return { Authorization: 'Bearer ' + token };
    } catch (e) {}
    return {};
};

GeneracionItems._get = function(path) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/generacion' + path,
            method: 'GET', crossDomain: true, dataType: 'json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body);
            else resolve(body && body.dto !== undefined ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

GeneracionItems._post = function(path, data) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/generacion' + path,
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: data || {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body);
            else resolve(body && body.dto !== undefined ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Catálogo de campos filtrables: [{clave, label, tipo, operadores[], opciones[]}]. */
GeneracionItems.campos = function() { return this._get('/campos'); };

/** Nº de expedientes que casan el filtro. Devuelve {total}. */
GeneracionItems.preview = function(filtro) { return this._post('/preview', filtro); };

/** Lanza la generación en segundo plano. Devuelve {lanzado} o {lanzado:false, enCurso:true}. */
GeneracionItems.lanzar = function(filtro) { return this._post('/lanzar', filtro); };

/** Cancela la generación en curso. */
GeneracionItems.cancelar = function() { return this._post('/cancelar', {}); };

/** Estado del job. Devuelve {enCurso}. */
GeneracionItems.estado = function() { return this._get('/estado'); };

export default GeneracionItems;
